import { cn } from '../../lib/cn';
import type { TestSuiteRow } from '../../enterprisequality/framework';

type Props = { suites?: TestSuiteRow[] };

export function TestManagementPanel({ suites = [] }: Props) {
  return (
    <div className="space-y-2">
      {suites.map((s) => (
        <div key={s.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{s.name}</p>
            <p className="text-xs text-slate-500">{s.feature} · {s.tests.toLocaleString()} tests</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            s.status === 'passed' || s.status === 'complete' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            s.status === 'in_progress' || s.status === 'active' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {s.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
